export default __webpack_public_path__ + "static/media/mty.9650b006.png";